import { FINPSP_DEPOSIT_TYPE, FINPSP_WITHDRAWAL_TYPE } from '../../constants/finpsp';

type ChannelOptions = { depositTypes?: string[]; withdrawalTypes?: string[] };

export type FinpspGatewayOptions = ChannelOptions & {
  id: string;
  providers?: (ChannelOptions & { id: string; name: string })[];
};

const resolveTypes = <T extends string>(
  gateway: FinpspGatewayOptions | undefined,
  bankType: string | null,
  key: keyof ChannelOptions,
  types: T[]
): T[] => {
  const provider = gateway?.providers?.find(({ id }) => id === bankType);
  const configured = provider?.[key] ?? gateway?.[key] ?? [FINPSP_DEPOSIT_TYPE.P2A];

  return types.filter((type) => Array.isArray(configured) && configured.includes(type));
};

export const resolveFinpspDepositTypes = (gateway: FinpspGatewayOptions | undefined, bankType: string | null) =>
  resolveTypes(gateway, bankType, 'depositTypes', Object.values(FINPSP_DEPOSIT_TYPE));

export const resolveFinpspWithdrawalTypes = (gateway: FinpspGatewayOptions | undefined, bankType: string | null) =>
  resolveTypes(gateway, bankType, 'withdrawalTypes', Object.values(FINPSP_WITHDRAWAL_TYPE));
